module.exports = __webpack_public_path__ + "media/images/dashboard/light/tile_icon_signal_data-f823abb53b10e21bbcbe53c497a3db99.png";